import { MINUTE_MS } from '$helper/functions/time'

//============================ Message ============================

//============== ViewCount ==============

export const MIN_TIME_FROM_LAST_UPDATE_TO_UPDATE_VIEW_COUNT = MINUTE_MS * 2
export const MIN_TIME_FROM_SENDING_MESSAGE_TO_UPDATE_VIEW_COUNT = MINUTE_MS
